import { CAPTCHA_ACTIONS, createCaptcha, useCaptcha } from '@percent/utility'
import { config } from '@percent/workplace-giving/config/config'

const captcha = createCaptcha(() => config.keys.recaptchaSiteKey)

export const useLoginCaptcha = () => useCaptcha(captcha, CAPTCHA_ACTIONS.login)

export const useForgotPasswordCaptcha = () => useCaptcha(captcha, CAPTCHA_ACTIONS.forgotPassword)
